<h2 mat-dialog-title>Are you sure you want to switch view mode?</h2>
<mat-dialog-content>Page will be reloaded.</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>
